module.exports = __webpack_public_path__ + "img/project-suivi_manual_filled.e2d2ad32.png";